/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable multiline-ternary */
/* eslint-disable no-cond-assign */

'use client'

import { useState, useEffect } from 'react'
import { convertToSlug } from 'src/utils/IdGenerator'
import Image from 'next/image'
import assetLoader from '@utils/internalImageLoader'
import styles from './quick-link2.module.scss'
import QuickLinkList from './quick-link-list'
import QuickLinkButton from './quick-link-button'

const QuickLinkWrapper = ({
  productPageResponse,
  updateIsSticky,
  quickLinksRef,
  segmentEventCommonProperties,
  windowWidth,
  isQuickLinksVisible,
}) => {
  const [isToggle, setIsToggle] = useState(false)
  const [isSticky, setIsSticky] = useState(false)
  const [quickLinksSection, setQuickLinksSection] = useState<any>(null)
  const [showDropdown, setShowDropdown] = useState(false)
  const [activeSectionId, setActiveSectionId] = useState<any>(null)
  const [selectedListItem, setSelectedListItem] = useState('What is Auto Insurance')

  // dropdown hidden based on user clicks
  useEffect(() => {
    const handleClickOutside = event => {
      if (quickLinksRef.current && !quickLinksRef.current.contains(event.target) && isToggle) {
        setIsToggle(false)
      }
    }

    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [isToggle])

  useEffect(() => {
    const handleScroll = () => {
      if (!quickLinksSection) return

      const sectionTop = quickLinksSection.offsetTop
      const sectionHeight = quickLinksSection.offsetHeight
      const scrollPosition = window.scrollY
      const scrollDistance = scrollPosition - sectionTop
      const scrollPercentage = (scrollDistance / sectionHeight) * 100

      setIsSticky(scrollPercentage >= 100)

      let adjustedScrollPosition = scrollPosition

      if (isSticky) {
        setIsToggle(false)
        adjustedScrollPosition -= sectionHeight
      }

      const visibleSectionId = productPageResponse[0].attributes.content
        .flatMap(item => {
          if (item.Content?.data) {
            const contentData = Array.isArray(item.Content.data) ? item.Content.data : [item.Content.data]
            return contentData.flatMap(contentItem => {
              const { content, sectionHeading, headerTabName, videoHeader, tableSectionHeading } =
                contentItem.attributes
              const h2Regex = /<h2[^>]*>(.*?)<\/h2>/g
              const h2Tags: any = []

              // Extract h2 tags from the content
              let matches
              while ((matches = h2Regex.exec(content)) !== null) {
                h2Tags.push(convertToSlug(matches[1])) // Pushing the slug of h2 tags
              }

              // Extract headerTabName if it exists and use it instead of h2
              if (headerTabName !== null && headerTabName !== undefined) {
                h2Tags.push(convertToSlug(headerTabName)) // Pushing the slug of headerTabName
              } else {
                // If headerTabName doesn't exist, use another name or sectionHeading
                const nameToUse = sectionHeading || content
                if (nameToUse) {
                  // Extract the name from sectionHeading or content and push its slug
                  const nameRegex = /<h2[^>]*>(.*?)<\/h2>/g // You might need to adjust the regex based on your content structure
                  const nameMatches = nameRegex.exec(nameToUse)
                  if (nameMatches && nameMatches.length > 1) {
                    h2Tags.push(convertToSlug(nameMatches[1]))
                  }
                }
              }
              // Add video header to the list of items that can be selected
              if (videoHeader) {
                const videoMatch = h2Regex.exec(videoHeader)
                if (videoMatch !== null) h2Tags.push(convertToSlug(videoMatch[1]))
                // h2Tags.push(convertToSlug(videoHeader))
              }
              if (tableSectionHeading) {
                const tableSectionMatch = h2Regex.exec(tableSectionHeading)
                if (tableSectionMatch !== null) h2Tags.push(convertToSlug(tableSectionMatch[1]))
              }

              return h2Tags
            })
          }
          return []
        })
        .map(id => {
          const element = document.getElementById(id)
          if (element) {
            const elementTop = element.offsetTop - 180
            const elementHeight = element.offsetHeight + 80
            if (adjustedScrollPosition >= elementTop && adjustedScrollPosition < elementTop + elementHeight) {
              setSelectedListItem(id.toUpperCase())
              return id
            }
          }
          return null
        })
        .find(id => id !== null)

      setActiveSectionId(visibleSectionId)
    }

    const sectionElement = document.getElementById('quickLinksSection')
    if (sectionElement) {
      setQuickLinksSection(sectionElement)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [quickLinksSection, isSticky])

  const handleSeeMoreClick = (text, isSticky) => {
    setIsToggle(!isToggle)
    setShowDropdown(false)

    if (text === 'showLess' && !isSticky) {
      const quickLinksSection = document.getElementById('quickLinksSection')
      if (quickLinksSection) {
        quickLinksSection.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <div className={`${styles.quickLink} ${isSticky ? styles.sticky : ''} ${isSticky ? styles.stickyLink : ''}`}>
      <h2 className={`${styles.heading} ${styles.mobileHeading}`}>
        {isQuickLinksVisible && (
          <Image
            src={`${assetLoader()}/images/quick-links-icon/LINKS.svg`}
            width={48}
            height={48}
            alt="LINKs icon"
            loading="lazy"
            decoding="async"
          />
        )}
        Quick Links
      </h2>
      {/* for mobile sticky quick link */}
      <ul className={styles.mobileHeadingLi}>
        <li
          onClick={e => {
            setShowDropdown(!showDropdown)
            updateIsSticky(!showDropdown)
          }}
          className={`${styles.liLink}`}>
          {selectedListItem}
          <div>
            {isQuickLinksVisible &&
              (showDropdown ? (
                <Image
                  src={`${assetLoader()}/images/quick-links-icon/down.svg`}
                  className={styles.dropdownBtn}
                  alt="dropdown button"
                  width={10}
                  height={8}
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <Image
                  src={`${assetLoader()}/images/quick-links-icon/up.svg`}
                  className={styles.dropdownBtn}
                  alt="dropdown button"
                  width={10}
                  height={8}
                  loading="lazy"
                  decoding="async"
                />
              ))}
          </div>
        </li>
      </ul>
      <QuickLinkList
        productPageResponse={productPageResponse}
        isToggle={isToggle}
        showDropdown={showDropdown}
        setShowDropdown={setShowDropdown}
        isSticky={isSticky}
        activeSectionId={activeSectionId}
        setIsToggle={setIsToggle}
        setSelectedListItem={setSelectedListItem}
        segmentEventCommonProperties={segmentEventCommonProperties}
        windowWidth={windowWidth}
        isQuickLinksVisible={isQuickLinksVisible}
      />
      <QuickLinkButton
        isToggle={isToggle}
        handleSeeMoreClick={handleSeeMoreClick}
        isSticky={isSticky}
        isQuickLinksVisible={isQuickLinksVisible}
      />
    </div>
  )
}

export default QuickLinkWrapper
